import { z } from 'zod';
import { SanityDocumentSchema, SanityFileAssetSchema, SanitySlugSchema } from '../sanity';
import { MiscTypes } from '../../types';
import { CardContentFieldsSchema } from '../shared/CardContent';

export const FileObjectSchema = z.object({
  asset: SanityFileAssetSchema
});

export const DocumentSchema = SanityDocumentSchema.extend({
  _type: z.literal(MiscTypes.Document),
  name: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  slug: SanitySlugSchema,
  file: FileObjectSchema.nullish(),
  cardContent: CardContentFieldsSchema.nullish(),
  format: z.string().nullish(),
  sortDate: z.string().nullish()
});

export type Document = z.infer<typeof DocumentSchema>;
export type FileObject = z.infer<typeof FileObjectSchema>;
